import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import { WorkRule } from 'repository/timekeeper/@types/WorkRuleModel';
import { PaperComponent } from 'shared/ui/draggable/Draggable';
import { useWorkRulesForm } from 'hooks/workRules/useWorkRulesForm';
import { AlertCustom } from 'shared/ui/alert/AlertCustom';
import { FormDelete } from '../paycode/FormDelete';
import { WorkRuleForm } from './WorkRuleForm';

interface WorkRuleFormDialogProps {
    open: boolean;
    onClose: () => void;
    reloading: () => void;
    rows: WorkRule[];
    mode: 'add' | 'edit' | 'delete' | 'info' | 'duplicate';
    selectedRow: WorkRule[];
}

export const WorkRuleDialog = ({ open, onClose, reloading, rows, mode, selectedRow }: WorkRuleFormDialogProps) => {
    const { t } = useTranslation();
    const form = useWorkRulesForm({ rows, onClose, reloading, mode, selectedRow, open });

    /* const requiredPermissions = [
        'timekeeper.BreakRule',
        'timekeeper.BonusRule',
        'timekeeper.RoundingRules',
        'timekeeper.ExceptionRules',
        'timekeeper.GetPaycodesDistribution',
        'timekeeper.ScheduleDesviationRule',
        'timekeeper.OvertimeRules',
        'timekeeper.Zones',
    ]; */

    //const editModePermissions = [...requiredPermissions, 'timekeeper.RoundingRulesById'];

    //const permissions = JSON.parse(localStorage.getItem('permissions') || '[]');
    //const permissionsToCheck = mode === 'edit' ? editModePermissions : requiredPermissions;
    //const hasAllPermissions = permissions.filter((permission: string) => permissionsToCheck.includes(permission)).length === permissionsToCheck.length;
    //const missingPermissions = permissionsToCheck.filter((perm) => !permissions.includes(perm));

    return (
        <Dialog
            open={open}
            onClose={(event, reason) => {
                if (reason !== 'backdropClick') {
                    return;
                }
                if (mode === 'delete') {
                    onClose();
                } else {
                    form.detectChanges();
                }
            }}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
            fullWidth
            autoFocus
            maxWidth="md"
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                {mode === 'add' && t('settings.work_rules.titles.add')}
                {mode === 'edit' && t('settings.work_rules.titles.edit')}
                {mode === 'duplicate' && ` ${t('settings.work_rules.titles.duplicate')}`}
                {mode === 'info' && t('settings.work_rules.titles.info')}
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={() => {
                    if (mode === 'delete') {
                        onClose();
                    } else {
                        form.detectChanges();
                    }
                }}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>
            <Box sx={{ top: 0, zIndex: 10, pb: 1 }}>{form.alert && <AlertCustom alerts={form.alert} setAlerts={form.setAlert} closeForm={form.cleanForm} t={t} />}</Box>
            {/* {!hasAllPermissions && (
                <Alert severity="warning" sx={{ mt: 2, ml: 2.5, mr: 2.5 }}>
                    <AlertTitle>{t('general.alerts.missing_permission.title')}</AlertTitle>

                    <List dense>
                        {missingPermissions.map((permission) => (
                            <ListItem key={permission}>
                                <ListItemText primary={permission} />
                            </ListItem>
                        ))}
                    </List>
                </Alert>
            )} */}
            <DialogContent dividers>
                {mode === 'delete' ? (
                    <FormDelete
                        open={open}
                        title={t('settings.work_rules.table.dialog.delete.title')}
                        description={t('settings.work_rules.table.dialog.delete.description')}
                        onCancel={form.cleanForm}
                        onConfirm={form.handleSubmit}
                        names={selectedRow.map((row) => row.name)}
                        textButton={t('general.buttons.delete')}
                        mode={mode}
                    />
                ) : (
                    <WorkRuleForm form={form} mode={mode} />
                )}
            </DialogContent>
            {mode === 'info' && (
                <DialogActions>
                    <Button variant="contained" disableElevation onClick={() => form.cleanForm()}>
                        {t('general.buttons.close')}
                    </Button>
                </DialogActions>
            )}
            {mode !== 'delete' && mode !== 'info' && (
                <DialogActions sx={{ pb: 2, pr: 3 }}>
                    <Button variant="contained" disableElevation color="error" onClick={() => form.cleanForm()}>
                        {t('general.buttons.cancel')}
                    </Button>
                    <Button variant="contained" disableElevation onClick={() => form.handleSubmit()} disabled={form.disabled}>
                        {t('general.buttons.save')}
                    </Button>
                </DialogActions>
            )}
        </Dialog>
    );
};

// Keep legacy imports working while the codebase migrates to WorkRuleDialog.
export const WorkRuleFormDialog = WorkRuleDialog;
